import { useSelector } from "react-redux";
import { plansSelector } from "../../Reducers/plansReducer";

const PlanBadge = ({planRaw}) => {
  const plansObj = useSelector(plansSelector);

  if (!plansObj.isPlanNameValid(planRaw)) {
    return <div>{planRaw}</div>
  }

  return (
    <div className={plansObj.isPaid(planRaw) ? "green-button" : "red-button"}>{plansObj.getDisplayName(planRaw)}</div>
  )
}
export default PlanBadge
